import React, { useEffect, useRef, useState } from "react"
import * as Yup from "yup"
import {
  Col,
  Container,
  Row,
  CardTitle,
  Label,
  Input,
  Button,
  Form,
  Spinner,
} from "reactstrap"

import file from "../../assets/images/icons/file-type.svg"
import ArrowDown from "../../assets/images/icons/ArrowDown.svg"
import editIcon from "../../assets/images/icons/edit.svg"
import { addSpaceEveryNChars, checkExtension } from "helpers/common"
import { Link, useNavigate } from "react-router-dom"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"
import {
  useKycFinalSubmissionMutation,
  useUpdateKycStepMutation,
} from "store/api/kyc/kyc"
import { useDispatch, useSelector } from "react-redux"
import { setLoginUserData } from "store/slices/userSlice"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
// import Select from "react-select"
import Select, { components } from "react-select"

import { depositories } from "helpers/depositories"
import { reactSelectStyles } from "helpers/utils"

const CustomDropdownIndicator = (props) => {
  const { isDisabled } = props.selectProps

  return (
    <components.DropdownIndicator {...props}>
      {!isDisabled ? <img className="cp" src={ArrowDown} alt="" /> : <></>}
    </components.DropdownIndicator>
  )
}

const KycFinalStep = ({ kycData }) => {
  const [kycFinalSubmission, { isLoading }] = useKycFinalSubmissionMutation()
  const { user } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const accountHolderRef = useRef()
  const accountNoRef = useRef()
  const bankNameRef = useRef()
  const ifscRef = useRef()
  const dematAccNoRef = useRef()
  const [politicalExDisabled, setPoliticalExDisabled] = useState(true)
  const [isDisabled, setIsDisabled] = useState(true)
  const [updateStep, { isLoading: isUpdatting }] = useUpdateKycStepMutation()

  const goToStep = async (step) => {
    try {
      await updateStep({ kyc_status: step }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  const politicalExposeOptions = [
    "Not Applicable",
    "Politically Exposed Person",
    "Related to Politically Exposed Person",
  ]

  const submitForVerification = async (data) => {
    try {
      const { message, success } = await kycFinalSubmission({
        entity_type: kycData.entity_type,
        kycStep: kycData.status,
        data,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })

        dispatch(
          setLoginUserData({
            user: { ...user, kyc_status: "SUBMITTED" },
          })
        )
        navigate("/")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      investorsDematDetails: {
        demat_account_no:
          kycData?.investorsDematDetails?.demat_account_no || "",
        depository_participant_name:
          kycData?.investorsDematDetails?.depository_participant_name || "",
        exchange_type: kycData?.investorsDematDetails?.exchange_type || "",
      },
      additionalDetails: {
        politicalExposure: kycData?.additionalDetails?.politicalExposure || "",
      },
    },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await submitForVerification(values)
    },
  })

  useEffect(() => {
    if (validation?.values?.investorsDematDetails?.demat_account_no) {
      const val = validation.values.investorsDematDetails.demat_account_no
      if (val.toLowerCase().startsWith("in")) {
        validation.setFieldValue("investorsDematDetails", {
          ...validation.values.investorsDematDetails,
          exchange_type: "NSDL",
        })
      } else if (val.toLowerCase().startsWith("12")) {
        validation.setFieldValue("investorsDematDetails", {
          ...validation.values.investorsDematDetails,
          exchange_type: "CDSL",
        })
      }
    }
  }, [validation?.values?.investorsDematDetails?.demat_account_no])

  const getDepositoryParticipantValue = () => {
    const v =
      validation.values.investorsDematDetails.depository_participant_name
    return {
      label: v,
      value: v,
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          marginTop: "6rem",
          paddingInline: "2rem",
        }}
      >
        <Form
          className="form-horizontal"
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row>
            <Col xl={12}>
              <div>
                <div>
                  <div className="d-flex align-items-center mt-4 mb-4 justify-content-between">
                    <CardTitle className="">Personal Details</CardTitle>
                  </div>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">Name</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={kycData?.investorsAadhaar?.name}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Date of Birth</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={kycData?.investorsAadhaar?.dob}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">PAN</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={kycData?.investorsPAN?.pan}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Aadhaar No.</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={addSpaceEveryNChars(
                          kycData?.investorsAadhaar?.aadhaar_no
                        )}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Phone No.</Label>
                      <Input
                        disabled
                        name="phone"
                        type="text"
                        className="form-control"
                        value={kycData?.phone}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Email Address</Label>
                      <Input
                        disabled
                        name="email"
                        type="text"
                        className="form-control"
                        value={kycData?.email}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Political Exposure
                      </Label>
                      <div className="input-wrapper">
                        <select
                          disabled={politicalExDisabled}
                          id="politicalExposure"
                          name="politicalExposure"
                          className={`form-select pageSize ${
                            politicalExDisabled ? "with-icon" : ""
                          }`}
                          value={
                            validation.values.additionalDetails
                              .politicalExposure
                          }
                          onChange={(e) =>
                            validation.setFieldValue("additionalDetails", {
                              ...validation.values.additionalDetails,
                              politicalExposure: e.target.value,
                            })
                          }
                        >
                          <option value="">Select</option>
                          {politicalExposeOptions.map((item, index) => (
                            <option
                              key={`political_exposure_${index}`}
                              value={item}
                            >
                              {item}
                            </option>
                          ))}
                        </select>
                        {politicalExDisabled && (
                          <div onClick={() => setPoliticalExDisabled(false)}>
                            <img className="cp" src={editIcon} alt="" />
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <div>
                <div>
                  <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                    <CardTitle className="">Bank Details</CardTitle>
                  </div>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Account Holders Name
                      </Label>
                      <Input
                        disabled
                        innerRef={accountHolderRef}
                        name="account_holder"
                        type="text"
                        className="form-control"
                        value={
                          kycData?.investorsBankDetails?.account_holder || ""
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Account Number</Label>

                      <Input
                        innerRef={accountNoRef}
                        disabled
                        name="account_no"
                        type="text"
                        className="form-control"
                        value={kycData?.investorsBankDetails?.account_no || ""}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Bank Name</Label>
                      <Input
                        disabled
                        innerRef={bankNameRef}
                        name="bank_name"
                        type="text"
                        className="form-control"
                        value={kycData?.investorsBankDetails?.bank_name || ""}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">IFSC</Label>
                      <Input
                        innerRef={ifscRef}
                        disabled
                        name="ifsc"
                        type="text"
                        className="form-control"
                        value={kycData?.investorsBankDetails?.ifsc || ""}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>

          {kycData?.investorsDematDetails && (
            <Row>
              <Col xl={12}>
                <div>
                  <div>
                    <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                      <CardTitle className="">Demat Details</CardTitle>
                    </div>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Demat Account Number
                        </Label>
                        <div className="input-wrapper">
                          <Input
                            innerRef={dematAccNoRef}
                            disabled
                            name="demat_account_no"
                            type="text"
                            className="form-control"
                            onChange={(e) =>
                              validation.setFieldValue(
                                "investorsDematDetails",
                                {
                                  ...validation.values.investorsDematDetails,
                                  demat_account_no: e.target.value,
                                }
                              )
                            }
                            value={
                              validation.values.investorsDematDetails
                                .demat_account_no
                            }
                          />
                          <div
                            onClick={() =>
                              (dematAccNoRef.current.disabled = false)
                            }
                          >
                            <img className="cp" src={editIcon} alt="" />
                          </div>
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Depository Participant Name
                        </Label>
                        <div className="input-wrapper">
                          <Select
                            className={
                              isDisabled ? "react-select-disabled" : ""
                            }
                            isDisabled={isDisabled}
                            styles={reactSelectStyles}
                            options={depositories}
                            placeholder="Select Name"
                            value={getDepositoryParticipantValue()}
                            onChange={(e) => {
                              validation.setFieldValue(
                                "investorsDematDetails",
                                {
                                  ...validation.values.investorsDematDetails,
                                  depository_participant_name: e.value,
                                }
                              )
                            }}
                            components={{
                              DropdownIndicator: CustomDropdownIndicator,
                            }}
                          />
                          {isDisabled && (
                            <div onClick={() => setIsDisabled(false)}>
                              <img className="cp" src={editIcon} alt="" />
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Depository Name
                        </Label>
                        <div className="input-wrapper">
                          <Input
                            name="exchange_type"
                            type="text"
                            className="form-control"
                            disabled
                            value={
                              validation.values.investorsDematDetails
                                .exchange_type
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          <Row>
            <Col xl={12}>
              <CardTitle className="mt-4 mb-4">Documents</CardTitle>

              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Personal KYC
              </CardTitle>
              <div className="documents-section">
                {kycData?.investorsAadhaar?.aadhaar_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        kycData?.investorsAadhaar.aadhaar_file_url
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Aadhaar</p>
                        <Link
                          to={kycData?.investorsAadhaar.aadhaar_file_url}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {kycData?.avatar_url && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(kycData?.avatar_url) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Selfie</p>
                        <Link to={kycData?.avatar_url} target="_blank">
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {kycData?.investorsPAN?.pan_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(kycData?.investorsPAN?.pan_file_url) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>PAN</p>
                        <Link
                          to={kycData?.investorsPAN?.pan_file_url}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {kycData?.avatar_url && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(kycData?.avatar_url) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Selfie</p>
                        <Link to={kycData?.avatar_url} target="_blank">
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
              </div>

              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Banking Documents
              </CardTitle>
              <div className="documents-section">
                {kycData?.investorsDematDetails?.cml_report && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        kycData?.investorsDematDetails?.cml_report_url
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>CML Report</p>
                        <Link
                          to={kycData?.investorsDematDetails.cml_report_url}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
                {kycData?.investorsBankDetails?.cheque_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        kycData?.investorsBankDetails.cheque_file_url
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Cheque</p>
                        <Link
                          to={kycData?.investorsBankDetails.cheque_file_url}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                      <p></p>
                    </div>
                    {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                  </div>
                )}
              </div>
              <div className="buttons">
                {/* <button
                  type="button"
                  onClick={() => goToStep("PHOTO")}
                  disabled={isLoading || isUpdatting}
                  className="btn btn-primary prev-button"
                >
                  {isUpdatting ? <Spinner size={"sm"} /> : "Previous Page"}
                </button> */}
                <Button
                  type="submit"
                  className="btn btn-primary w-md"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinners /> : "Submit for Verification"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </React.Fragment>
  )
}

export default KycFinalStep
